<template>
  <div
    class="bg-white rounded-md border border-grey-300 overflow-hidden shadow mt-4"
  >
    <div class="border-b border-grey-300 px-5 py-4">
      <div class="flex justify-between items-center">
        <p class="text-base text-dark font-semibold">
          {{
            $t('frontend_groovemember_left_panel_membership_outline_heading')
          }}
        </p>
      </div>
    </div>
    <div class="mt-3">
      <section>
        <div id="all_nav_names">
          <!--Start Category Section--->
          <div
            v-for="(catOutline, index) in membershipOutline"
            :key="index"
            class="border-l-4 font-semibold text-sm px-4"
            :class="catOutline.isBorder ? 'border-pink' : 'border-white'"
          >
            <div
              class="w-full flex flex-row select-none justify-between cursor-pointer"
            >
              <div
                @click="clickCat(catOutline, index)"
                class="flex flex-row justify-between w-full text-sm"
              >
                <span class="text-sm px-4 py-3 text-gray-700">{{
                  catOutline.name
                }}</span>
                <div
                  class="mt-2 mr-2 text-gray-700"
                  v-if="catOutline.default == 0"
                >
                  <span v-if="catOutline.isCollapse">
                    <i class="fa fa-angle-up"></i>
                  </span>
                  <span v-else><i class="fa fa-angle-down"></i></span>
                </div>
              </div>
            </div>
            <transition name="fade">
              <div
                class="w-full"
                v-if="catOutline.isCollapse && catOutline.default == 0"
              >
                <div>
                  <!----Start Sub Category Section-->
                  <ul
                    v-for="(subcatOutline, index2) in catOutline.subCat"
                    :key="index2"
                  >
                    <li id="subcat_parent_iAZ2Iu3yse">
                      <div class="text-md subcat_parent px-4 py-3">
                        <p
                          v-if="subcatOutline.isAccess"
                          @click="
                            pageClick(
                              subcatOutline.id,
                              subcatOutline.post.length > 0 ? false : true
                            )
                          "
                          class="ml-1 font-semibold text-sm px-4 cursor-pointer"
                          :class="
                            subcatOutline.isCurrent
                              ? 'text-pink'
                              : 'text-grey-700'
                          "
                        >
                          {{ subcatOutline.name }}
                        </p>
                        <div
                          v-else
                          class="post-link display-none text-grey-500 ml-1 pr-2 flex flex-row cursor-default justify-between"
                        >
                          <div>
                            {{ subcatOutline.name }}
                          </div>
                          <div class="mr-2">
                            <i class="fa fa-lock" />
                          </div>
                        </div>
                      </div>
                      <!----Start Post Section-->
                      <ul>
                        <li
                          v-for="(postOutline, index3) in subcatOutline.post"
                          :key="index3"
                          class="text-sm px-8 py-2"
                        >
                          <div>
                            <p
                              v-if="postOutline.isAccess"
                              data-link-id="iAZ2Iu3yse"
                              @click="pageClick(postOutline.id, true)"
                              class="post-link ml-1 font-semibold text-sm px-4 cursor-pointer"
                              :class="
                                postOutline.isCurrent
                                  ? 'text-pink'
                                  : 'text-grey-700'
                              "
                            >
                              {{ postOutline.name }}
                            </p>
                            <div
                              v-else
                              class="post-link px-4 display-none text-grey-500 ml-1 flex flex-row cursor-default justify-between"
                            >
                              {{ postOutline.name }} <i class="fa fa-lock" />
                            </div>
                          </div>
                        </li>
                      </ul>
                      <!----End Post Section-->
                    </li>
                  </ul>
                  <!----End Sub Category Section-->
                </div>
              </div>
            </transition>
          </div>
          <!--End Category Section--->
        </div>
      </section>
    </div>
  </div>
</template>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<script>
import {Bus} from '../../main'
export default {
  name: 'MembershipOutline',
  props: ['membershipOutline', 'changePage', 'isPreview'],
  methods: {
    pageClick(id, isSubcatClick) {
      if (this.isPreview || isSubcatClick) {
        this.changePage(id);
      }
      Bus.$emit('close-h-menu');
    },
    clickCat(catOutline, CIndex) {
      
      if(CIndex == '0'){
        Bus.$emit('close-h-menu');
      }
      this.membershipOutline[CIndex].isCollapse = !this.membershipOutline[
        CIndex
      ].isCollapse;

      this.membershipOutline.forEach((cat, lIndex) => {
        if (CIndex !== lIndex) {
          cat.isCollapse = false;
        }
      });

      this.$forceUpdate();

      /** Show default post in default cat */
      if (catOutline.default == 1) {
        this.changePage(catOutline.subCat[0].id);
      }
    },
  },
};
</script>